import { isValidUsernameShape, stripHandlePrefixes } from '@/lib/utils/regex';

export interface BasicProfileForLookup {
  name?: string | null;
  profileImageUrl?: string | null;
  username: string | null | undefined;
}

function normalizeUsername(username: string | null | undefined): string | null {
  if (!username) {
    return null;
  }
  const trimmed = username.trim();
  if (!trimmed) {
    return null;
  }
  const withoutAt = stripHandlePrefixes(trimmed);
  return isValidUsernameShape(withoutAt) ? withoutAt : null;
}

export function createProfileLookup(
  sources: Iterable<BasicProfileForLookup | null | undefined>
): Map<string, { username: string; name?: string | null; profileImageUrl?: string | null }> {
  const map = new Map<string, { username: string; name?: string | null; profileImageUrl?: string | null }>();

  for (const source of sources) {
    if (!source) {
      continue;
    }
    const normalized = normalizeUsername(source.username);
    if (!normalized) {
      continue;
    }
    const key = normalized.toLowerCase();
    if (map.has(key)) {
      continue;
    }
    map.set(key, {
      username: normalized,
      name: source.name ?? null,
      profileImageUrl: source.profileImageUrl ?? null,
    });
  }

  return map;
}

export function mergeProfileLookups(
  ...lookups: Array<
    Map<string, { username: string; name?: string | null; profileImageUrl?: string | null }> | null | undefined
  >
): Map<string, { username: string; name?: string | null; profileImageUrl?: string | null }> {
  const merged = new Map<string, { username: string; name?: string | null; profileImageUrl?: string | null }>();

  for (const lookup of lookups) {
    if (!lookup) {
      continue;
    }
    for (const [key, value] of lookup) {
      if (!merged.has(key)) {
        merged.set(key, value);
      }
    }
  }

  return merged;
}
